import styled from '@emotion/styled'

import { theme } from '../../constants'
import { Loader } from '../Loader'

const LoaderContainer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: ${theme.zIndex.backdrop};
`

export const Loading = () => {
  return (
    <LoaderContainer>
      <Loader delayed={true} design="fade" />
    </LoaderContainer>
  )
}
